module.exports = __webpack_public_path__ + "img/icon_fail@2x.1d817ae9.png";